
import axiosInstance from '@/lib/axios';



export async function fetchSecurityQuestions() {
    try {
        const response = await axiosInstance.get('/admin/security_questions');

        const data = response.data;

        if (!data || data.length === 0 || data.detail === 'No security questions found') {
            return [];
        }

        return data;
    } catch (error) {
        const errData = error.response?.data;

        // Graceful handling if backend says "No security questions found"
        if (errData?.detail === 'No security questions found') {
            return [];
        }

        throw new Error(
            `Failed to fetch security questions: ${errData?.detail || JSON.stringify(errData) || error.message}`
        );
    }
}



export async function setupRecoverySystem(data) {
    try {


        const { data: responseData } = await axiosInstance.post(
            '/users/users_security_questions',
            data
        );


        return responseData;
    } catch (error) {
        console.error('Error setting up recovery system:', error);
        throw error;
    }
}

